const getters = {
  accounts: state => state.account.accounts,
  totalAccount: state => state.account.totalAccount,

  devices: state => state.device.devices,
  totalDevice: state => state.device.totalDevice,

  vehicles: state => state.vehicle.vehicles,
  totalVehicle: state => state.vehicle.totalVehicle,

  sims: state => state.sim.sims,
  totalSim: state => state.sim.totalSim,

  token: state => state.user.token,
  refreshToken: state => state.user.refreshToken,
  loggedUser: state => state.user.loggedUser,
};
export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js